import { buildTemporaryWorktreeBranchName } from "@cmmd-forge/shared/git";

import type {
  StartThreadForItemInput,
  ThreadLaunchConfiguration,
  ThreadLaunchProject,
} from "./NoActiveThreadState.threadRunner";

const WORKTREE_PROJECT_CWD_MISSING_MESSAGE =
  "The project checkout is not available yet, so Forge cannot create the worktree. Retry in a moment.";

export function resolveWorktreeBootstrap(
  input: StartThreadForItemInput,
  project: ThreadLaunchProject | null,
) {
  const configuration = input.launchConfiguration;
  if (configuration?.environmentMode !== "worktree") {
    return {};
  }
  if (!project?.cwd) {
    throw new Error(WORKTREE_PROJECT_CWD_MISSING_MESSAGE);
  }
  return {
    bootstrap: {
      prepareWorktree: {
        projectCwd: project.cwd,
        // baseBranch may be null: the server resolves the repo default
        // branch itself, so an unresolved branch still reaches the server
        // instead of silently dropping the worktree request.
        baseBranch: configuration.baseBranch,
        branch: buildTemporaryWorktreeBranchName(),
      },
      runSetupScript: true,
    },
  };
}

export function resolveWorktreeBootstrapFromConfiguration(input: {
  readonly launchConfiguration: ThreadLaunchConfiguration | undefined;
  readonly targetProject: ThreadLaunchProject | null;
}) {
  const configuration = input.launchConfiguration;
  if (configuration?.environmentMode !== "worktree") {
    return {};
  }
  if (!input.targetProject?.cwd) {
    throw new Error(WORKTREE_PROJECT_CWD_MISSING_MESSAGE);
  }
  return {
    prepareWorktree: {
      projectCwd: input.targetProject.cwd,
      // baseBranch may be null: the server resolves the repo default branch
      // itself, so an unresolved branch still reaches the server instead of
      // silently dropping the worktree request.
      baseBranch: configuration.baseBranch,
      branch: buildTemporaryWorktreeBranchName(),
    },
    runSetupScript: true,
  };
}
